const hostname = window.location.hostname.toLowerCase();

type OidcEnv = 'localhost' | 'pintlab' | 'pintlab2' | 'prod';

const resolveOidcEnv = (): OidcEnv => {
  if (hostname === 'localhost' || hostname.includes('activate-localhost.oraclecloud.com')) {
    return 'localhost';
  }
  if (hostname === 'activate-pintlab.oraclecloud.com') {
    return 'pintlab';
  }
  if (hostname === 'activate-pintlab2.oraclecloud.com') {
    return 'pintlab2';
  }
  if (hostname === 'activate.oraclecloud.com' || hostname === 'activate.cloud.oracle.com') {
    return 'prod';
  }

  // Limited to supported realms only. Default to prod behavior for unknown hosts.
  return 'prod';
};

const env = resolveOidcEnv();

const origin = window.location.origin;
const sharedAuthority = 'https://idcs-9dc693e80d9b469480d7afe00e743931.identity.oraclecloud.com';
const sharedClientId = 'adfc398babec4d7aa8c272c195f94f42';

const oidcConfigByEnv: Record<OidcEnv, Record<string, any>> = {
  localhost: {
    redirect_uri: `${origin}/callback`,
    silent_redirect_uri: `${origin}/silent-callback`,
  },
  pintlab: {
    redirect_uri: `${origin}/callback`,
    silent_redirect_uri: `${origin}/silent-callback`,
  },
  pintlab2: {
    redirect_uri: `${origin}/callback`,
    silent_redirect_uri: `${origin}/silent-callback`,
  },
  prod: {
    redirect_uri: `${origin}/callback`,
    silent_redirect_uri: `${origin}/silent-callback`,
  },
};

export const oidcConfig = {
  authority: sharedAuthority,
  client_id: sharedClientId,
  ...oidcConfigByEnv[env],
  response_type: 'code',
  scope: 'openid offline_access',
  automaticSilentRenew: true,
  loadUserInfo: true,
  accessTokenExpiringNotificationTime: 300,
};
